import { z } from 'zod';

/** The single client an `AuthUser` scoped to exactly one client resolves to — used by /v1/client_area/client. */
export const clientAreaCurrentClientSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  allowCaptionSuggestions: z.boolean(),
  agency: z.object({
    id: z.string(),
    name: z.string(),
    image: z.string().nullable(),
  }),
});

export type ClientAreaCurrentClientSchema = z.infer<typeof clientAreaCurrentClientSchema>;
